import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../helpers/media.js';
import '../../../helpers/animation.js';

var _a;
var GlobalNotification = styled.div((_a = {
        width: "100%",
        backgroundColor: tokens.color.airJordan.p,
        color: tokens.color.yeezy.p,
        padding: "".concat(tokens.spacing[3], " ").concat(tokens.spacing[5]),
        textAlign: "center",
        fontFamily: tokens.fontFamilies.primary,
        fontSize: tokens.fontSize[2]
    },
    _a[mediaQuery.m.min] = {
        padding: "".concat(tokens.spacing[3], " ").concat(tokens.spacing[8]),
    },
    _a));

export { GlobalNotification };
//# sourceMappingURL=GlobalNotification.styles.js.map
